export const alertDetailPath = ["/home/detail", "/daily/alertdetail", "/hourly/alertdetail"];
export const isAlertDetail = () => {
  const { pathname } = useLocation();
  return alertDetailPath.some(item => pathname.startsWith(item));
};
